// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filters-collapse.ant-collapse
  > .ant-collapse-item-active
  > .ant-collapse-header {
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./client/modules/data-feeds/components/FiltersTab.css"],"names":[],"mappings":"AAAA;;;EAGE,eAAe;AACjB","sourcesContent":[":global .filters-collapse.ant-collapse\n  > .ant-collapse-item-active\n  > .ant-collapse-header {\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
